export class Descriptor {
  name: string
  labelKey: string
  icon: string
  rank?: number | null
  style?: string | null
  emphasized?: boolean | null

  constructor(
    name: string,
    labelKey: string,
    icon: string,
    rank?: number | null,
    style?: string | null,
    emphasized?: boolean | null,
  ) {
    this.name = name
    this.labelKey = labelKey
    this.icon = icon
    this.rank = rank
    this.emphasized = emphasized
    this.style = style
  }
}
